import { render } from "./JoinRacesTable.vue?vue&type=template&id=0a0496d0&ts=true"
import script from "./JoinRacesTable.vue?vue&type=script&lang=ts"
export * from "./JoinRacesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__